import { render } from "./CountryPackageCard.vue?vue&type=template&id=965b979a&ts=true"
import script from "./CountryPackageCard.vue?vue&type=script&lang=ts"
export * from "./CountryPackageCard.vue?vue&type=script&lang=ts"

import "./CountryPackageCard.vue?vue&type=style&index=0&id=965b979a&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__